
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { SectionTitle } from "@/components/SectionTitle";
import { Button } from "@/components/ui/button";
import { MapPin, Clock, ExternalLink } from "lucide-react";
import { PageTitle } from "@/components/PageTitle";

const Clinics = () => {
  const clinics = [
    {
      id: 1,
      name: "Asrani Dental Clinic - Jaripatka",
      address: "Jaripatka, Nagpur, Maharashtra",
      hours: "7:00 PM - 10:00 PM (Mon - Sat)",
      googleMapUrl: "https://g.co/kgs/23LXGA6",
      directions: "https://www.google.com/maps/dir//Asrani+Dental+Clinic+-+Jaripatka"
    },
    {
      id: 2,
      name: "Asrani Dental Clinic - Itwari",
      address: "Itwari, Nagpur, Maharashtra",
      hours: "10:00 AM - 3:00 PM & 6:00 PM - 9:00 PM (Mon - Sat)",
      googleMapUrl: "https://g.co/kgs/TD2ujAQ",
      directions: "https://www.google.com/maps/dir//Asrani+Dental+Clinic+-+Itwari"
    }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <PageTitle title="Clinics – Asrani Dental Clinic" />
      <Header />
      <main className="flex-grow pt-24 lg:pt-28 bg-dental-offwhite">
        <div className="container-custom py-12 md:py-16">
          <SectionTitle
            title="Our Locations"
            subtitle="Visit us"
            description="We have multiple clinics across Nagpur to serve you better. Each clinic is equipped with the latest technology and staffed by our experienced dental professionals."
            alignment="center"
          />
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-12">
            {clinics.map((clinic) => (
              <div key={clinic.id} className="bg-white rounded-xl shadow-md overflow-hidden transform transition hover:shadow-lg">
                <div className="p-6">
                  <div className="mb-4">
                    <h3 className="text-2xl font-serif font-medium text-dental-text">{clinic.name}</h3>
                  </div>
                  
                  <div className="space-y-4 mb-6">
                    <div className="flex items-start">
                      <MapPin className="text-dental-highlight shrink-0 mt-1 mr-3" size={20} />
                      <p className="text-dental-muted">{clinic.address}</p>
                    </div>
                    
                    <div className="flex items-center">
                      <Clock className="text-dental-highlight mr-3" size={20} />
                      <p className="text-dental-muted">
                        {clinic.hours}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row gap-4">
                    <Button className="btn-primary flex-1 gap-2" asChild>
                      <a href={clinic.directions} target="_blank" rel="noopener noreferrer">
                        Get Directions <ExternalLink size={16} />
                      </a>
                    </Button>
                    <Button className="btn-secondary flex-1 gap-2" asChild>
                      <a href={clinic.googleMapUrl} target="_blank" rel="noopener noreferrer">
                        View on Google Maps <ExternalLink size={16} />
                      </a>
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-16 text-center">
            <h3 className="text-2xl font-serif font-medium mb-6">Need an appointment?</h3>
            <Button className="btn-primary" asChild>
              <a href="/dental-appointment-booking">Book an Appointment</a>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Clinics;
